import { TActivity } from '@/types';
import { CategoryCard } from './CategoryCard';

interface ICategoriesProps {
  categories: Array<TActivity>;
  selectedCategory: number;
  toggleSelect: (id: number) => void;
}

export const Categories = ({ categories = [], selectedCategory, toggleSelect }: ICategoriesProps) => {
  return (
    <>
      {categories.map((category) => (
        <CategoryCard
          key={category.id}
          categoryName={category.name}
          isSelected={selectedCategory === category.id}
          handleClick={() => toggleSelect(category.id)}
        />
      ))}
    </>
  );
};
